import axios from "../axiosInstance";
import { CompleteModuleRequest, CompleteModuleResponse } from "./types";

export const completeModule = async (
  requestData: CompleteModuleRequest,
): Promise<CompleteModuleResponse> => {
  const response = await axios.post<CompleteModuleResponse>(
    `/api/learning-center/modules/${requestData.id}/complete`,
  );

  return response.data;
};
